module.exports = __webpack_public_path__ + "media/images/new_culture/bg-8-6dc608a1bfcbcd984addab4ab7a28553.png";